import { Injectable } from "@angular/core"
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router'
import { Store, Action } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { Observable } from "rxjs/Observable"
import { Observer } from "rxjs/Observer"
import {
  FETCH_CONTACT,
  POPULATE_EDITABLE_CONTACT,
  POPULATE_ACTIVE_CONTACT
} from "@reducers/contacts"
import {
  FETCH_TEACHERS,
  POPULATE_TEACHERS
} from "@reducers/matrix-class"
import { ContactEffects } from "@reducers/effects/contact"
import { MatrixClassEffects } from "@reducers/effects/matrix-class"

@Injectable()
export class ContactViewResolver implements Resolve<boolean> {

  constructor(
    private contactEffects: ContactEffects,
    private matrixClassEffects: MatrixClassEffects,
    private router: Router,
    private store: Store<AppState>,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const result: Observable<boolean> = Observable.create((observer: Observer<boolean>) => {
      const a = this.matrixClassEffects.fetchTeachers
      const b = this.contactEffects.fetchContact
        
      return Observable.zip(a, b).take(1).subscribe((actions: Action[]) => {
        if (actions[0].type === POPULATE_TEACHERS &&
            actions[1].type === POPULATE_ACTIVE_CONTACT) {
          observer.next(true)
          observer.complete()
        }
      })
    })

    this.store.dispatch({ type: FETCH_CONTACT, payload: route.params['id'] })
    this.store.dispatch({ type: FETCH_TEACHERS })

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/contact-view.ts